import {
    ActiveChangeAmount,
    ActiveConfirmationModalContent,
    PredefinedCommentActiveConfirmModalAction,
} from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-list/settings-devices-predefined-comments-list.model';
import { PredefinedComment } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/predefined-comments.model';

export const getModalTexts = (
    action: PredefinedCommentActiveConfirmModalAction,
    predefinedComments: PredefinedComment[]
) => {
    const amountMode: ActiveChangeAmount = predefinedComments.length === 1 ? 'single' : 'multiple';

    return MODAL_CONTENT[action][amountMode];
};

const MODAL_CONTENT: Record<
    PredefinedCommentActiveConfirmModalAction,
    Record<ActiveChangeAmount, ActiveConfirmationModalContent>
> = {
    activate: {
        single: {
            buttonText: 'settings.devices.predefined-comments.list.actions.activate',
            headerText: 'settings.devices.predefined-comments.list.actions.activate-modal.title.single',
            bodyText: 'settings.devices.predefined-comments.list.actions.activate-modal.description.single',
        },
        multiple: {
            buttonText: 'settings.devices.predefined-comments.list.actions.activate',
            headerText: 'settings.devices.predefined-comments.list.actions.activate-modal.title.multiple',
            bodyText: 'settings.devices.predefined-comments.list.actions.activate-modal.description.multiple',
        },
    },
    deactivate: {
        single: {
            buttonText: 'settings.devices.predefined-comments.list.actions.deactivate',
            headerText: 'settings.devices.predefined-comments.list.actions.deactivate-modal.title.single',
            bodyText: 'settings.devices.predefined-comments.list.actions.deactivate-modal.description.single',
        },
        multiple: {
            buttonText: 'settings.devices.predefined-comments.list.actions.deactivate',
            headerText: 'settings.devices.predefined-comments.list.actions.deactivate-modal.title.multiple',
            bodyText: 'settings.devices.predefined-comments.list.actions.deactivate-modal.description.multiple',
        },
    },
};
